var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Loading", { attrs: { loadingHide: _vm.loadingHide } }),
      _vm._v(" "),
      _c("Header"),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "container personHomePage",
          class: _vm.device == "mobile" ? "mobileStyle" : "",
        },
        [
          _c("aside", { class: _vm.device == "mobile" ? "mobileStyle" : "" }, [
            _c("header", [
              _c("main", [
                _c("div", { staticClass: "left" }, [
                  _c("div", { staticClass: "avatarWrap" }, [
                    _c("img", {
                      staticClass: "userImg",
                      attrs: { src: _vm.user.avatar, alt: "" },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "right" }, [
                  _c("div", { staticClass: "userName" }, [
                    _c("span", [_vm._v(_vm._s(_vm.user.name))]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "userNum" }, [
                    _c("span", [
                      _c("i", [_vm._v(_vm._s(_vm.authorCount))]),
                      _vm._v("关注"),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _c("i", [_vm._v(_vm._s(_vm.followingCount))]),
                      _vm._v("粉丝"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.look == "self"
                    ? _c(
                        "div",
                        { staticClass: "userFun" },
                        [
                          _c(
                            "el-link",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.tabChange("personal", "个人资料")
                                },
                              },
                            },
                            [_vm._v("编辑资料")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _vm.look == "other"
                ? _c("footer", [
                    _c("div", [
                      _c(
                        "span",
                        {
                          class: _vm.zansStatus
                            ? "userLike ffe200"
                            : "userLike",
                          on: {
                            click: function ($event) {
                              return _vm.giveLike(_vm.user.id)
                            },
                          },
                        },
                        [_c("i", [_vm._v(_vm._s(_vm.likeNum))]), _vm._v("赞")]
                      ),
                    ]),
                    _vm._v(" "),
                    !_vm.studentId || _vm.user.id != _vm.studentId
                      ? _c("div", [
                          _c(
                            "span",
                            {
                              class: _vm.followStatus
                                ? "attention ffe200"
                                : "attention",
                              on: {
                                click: function ($event) {
                                  return _vm.attentionUser(_vm.user.id)
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.followStatus ? "已关注" : "关注")
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm.device != "mobile" && _vm.look != "other"
              ? _c("nav", [
                  _c("ul", [
                    !_vm.loginBtnShow
                      ? _c(
                          "li",
                          {
                            class: _vm.activeItem == "lesson" ? "active" : "",
                            on: {
                              click: function ($event) {
                                return _vm.tabChange("lesson", "我的课程")
                              },
                            },
                          },
                          [_vm._v("我的课程")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.loginBtnShow
                      ? _c(
                          "li",
                          {
                            class: _vm.activeItem == "myworks" ? "active" : "",
                            on: {
                              click: function ($event) {
                                return _vm.tabChange("myworks", "我的作品")
                              },
                            },
                          },
                          [_vm._v("我的作品")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.loginBtnShow
                      ? _c(
                          "li",
                          {
                            class: _vm.activeItem == "myexam" ? "active" : "",
                            on: {
                              click: function ($event) {
                                return _vm.tabChange("myexam", "我的考试")
                              },
                            },
                          },
                          [_vm._v("我的考试")]
                        )
                      : _vm._e(),
                  ]),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "section",
            { class: _vm.device == "mobile" ? "mobileStyle" : "" },
            [
              _c(
                "main",
                [
                  _c(
                    "header",
                    [
                      _vm.device == "mobile"
                        ? _c(
                            "el-dropdown",
                            {
                              attrs: { trigger: "click" },
                              on: { command: _vm.commandChange },
                            },
                            [
                              _c("span", { staticClass: "el-dropdown-link" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.activeItemName)
                                ),
                                _c("i", {
                                  staticClass:
                                    "el-icon-arrow-down el-icon--right",
                                }),
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-dropdown-menu",
                                {
                                  staticClass: "selfPage",
                                  attrs: { slot: "dropdown" },
                                  slot: "dropdown",
                                },
                                [
                                  !_vm.loginBtnShow &&
                                  this.hostName !=
                                    `kexie.${_vm.institutionConfig.baseDomainName}` &&
                                  this.hostName !=
                                    `roborobo.${_vm.institutionConfig.baseDomainName}`
                                    ? _c(
                                        "el-dropdown-item",
                                        {
                                          attrs: {
                                            command: {
                                              item: "lesson",
                                              itemName: "我的课程",
                                            },
                                          },
                                        },
                                        [_vm._v("我的课程")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      attrs: {
                                        command: {
                                          item: "myworks",
                                          itemName: "我的作品",
                                        },
                                      },
                                    },
                                    [_vm._v("我的作品")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      attrs: {
                                        command: {
                                          item: "myexam",
                                          itemName: "我的考试",
                                        },
                                      },
                                    },
                                    [_vm._v("我的考试")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _c("span", [_vm._v(_vm._s(_vm.activeItemName))]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.activeItem == "personal"
                    ? _c("Personal", { attrs: { community: true } })
                    : _c(
                        "article",
                        [
                          _vm.activeItem == "myworks"
                            ? _c("myWorks", {
                                attrs: { refresh: _vm.refresh, look: _vm.look },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.activeItem == "myexam" ? _c("myexam") : _vm._e(),
                          _vm._v(" "),
                          _vm.activeItem == "lesson" ? _c("lesson") : _vm._e(),
                        ],
                        1
                      ),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("Foot"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/views/personHome/personHome.vue?vue&type=template&id=98c90076&
// module id = null
// module chunks = 